import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import db from '../firebase';
import '../styles/chat.css';
import { List, ListItem, ListItemText, Paper, Typography } from '@mui/material';

const ApiLogs = () => {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const logsQuery = query(collection(db, 'apiLogs'), orderBy('timestamp', 'desc'), limit(6));
                const logsSnapshot = await getDocs(logsQuery);
                const fetchedLogs = logsSnapshot.docs.map(doc => doc.data());
                setLogs(fetchedLogs);
            } catch (error) {
                console.error('Error fetching logs:', error);
            }
        };

        fetchLogs();
    }, []);

    return (
        <Paper style={{ maxHeight: 500, width: '95%', overflow: 'auto', margin: '10px', padding: '10px' }}>
            <Typography variant="h6" gutterBottom>
                API Logs
            </Typography>
            <div id="content-body">
                <div id="messages">
                    {logs && logs.map((log, index) => (
                        <div class="user-message message">
                            <div class="message-div">
                                <div class="message-profile-pic"><img src="https://abs.twimg.com/sticky/default_profile_images/default_profile_400x400.png" height="30" width='30' />
                                <br/>
                                {log.timestamp.toDate().toLocaleString()}
                                </div>
                                <div class="message-content">
                                    <p>{log.request}</p>
                                </div>

                            </div>

                            <div class="gpt-message message">
                                <div class="message-div">
                                    <div class="message-profile-pic"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/ChatGPT_logo.svg/900px-ChatGPT_logo.svg.png" height="30" width='30' />
                                    </div>
                                    <div class="message-content">
                                        <p>{log.response}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </Paper >
    );
};

export default ApiLogs;